import { render, staticRenderFns } from "./CultureViImageAbolishInfo.vue?vue&type=template&id=4901346c&scoped=true&"
import script from "./CultureViImageAbolishInfo.vue?vue&type=script&lang=js&"
export * from "./CultureViImageAbolishInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901346c",
  null
  
)

export default component.exports